import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'

document.addEventListener('DOMContentLoaded', () => {
	let columnistsCarousel = document.querySelectorAll('.columnists-block-container .container.is-carousel')
	if (columnistsCarousel !== undefined && columnistsCarousel.length) {
		let sliders = [];
		let i = 1;

		columnistsCarousel.forEach((element) => {
			console.log(element);
			if(element.childElementCount >= 2) {
				sliders[i] = tns({
					container: element,
					items: 2,
					nav: false,
					controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="#626262" stroke-width="2" d="M15 6l-6 6l6 6"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="#626262" stroke-width="2" d="M9 6l6 6l-6 6"/></svg>'],
					mouseDrag: true,
					gutter: 10,
					responsive: {
						640: {
							items: 3
						},
						700: {
							gutter: 20,
							items: 5
						},
						900: {
							items: 6
						}
					}
				});
			}
			i++;
		})
	}
})
